<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img
        class="page_topreturn"
        src="/static/fanhui.png"
        @click="pageReturn()"
      />
      <div class="page_toptext">卡券详情</div>
      <img
        class="page_topreturnindex"
        src="/static/fanhuishouye.png"
        @click="pageToIndex()"
      />
    </div>
    <!-- 返回 结束 -->
    <div class="pro_coupon_top">
      <div class="pro_coupon_name">{{ couponsDetail.name }}</div>
      <div class="pro_coupon_desc">
        使用时间:{{ couponsDetail.created_at }} - {{ couponsDetail.overdue_at }}
      </div>
    </div>
    <div class="pro_productlist">
      <div class="pro_product_title">适用商品</div>
      <div class="pro_product_box" v-for="(item,index) in productList"  @click="toProDetail(index)">
        <img class="pro_productimg" :src="item.pro_thumb" />
        <div class="pro_productRight">
          <div class="pro_productName">{{ item.pro_name }}</div>
          <div class="pro_productPrice"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httper from "../../api/http";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  data() {
    return {
      id: 0,
      couponsDetail: {},
      productList: [],
      page: 1,
      page_size: 20
    };
  },
  created() {
    console.log("this.$route.query.id");
    this.id = this.$route.query.id ? Number(this.$route.query.id) : "";
  },
  mounted() {
    if (!this.id) return;
    let requestData = {
      id: this.id
    };
    this.request("getCouponDetail", requestData);
  },
  methods: {
    pageReturn() {
      this.$router.go(-1);
    },
    pageToIndex() {
      this.$router.push({
        path: "/"
      });
    },
    toProDetail(indexStr){
      console.log("i",indexStr);
      if(this.couponsDetail.coupon.pro_type==2){
        this.$router.push({
            path: '/offlineserverList',
            query: {
              product_id: this.productList[indexStr].pro_id
            }
        })
      }else if(this.couponsDetail.coupon.pro_type==3){
        let items = this.productList[indexStr]
         this.$router.push({
            path: '/shoppingDetail',
            query: {
              cate_id: this.productList[indexStr].cate_id,
              items:items
            }
        })
      }else if(this.couponsDetail.coupon.pro_type==4){
        let items = this.productList[indexStr]
         this.$router.push({
            path: '/youlegoudetail',
            query: {
              id: this.productList[indexStr].pro_id,
              items:items
            }
        })
      }
     
    },
    // 调用接口
    request(type = "", requestData = {}) {
      let that = this;
      let data = {};
      switch (type) {
        // 获取卡券详情
        case "getCouponDetail":
          httper.get("coupon/package-detail", requestData, res => {
            console.log("卡券详情", res.data);
            this.couponsDetail = res.data;
            this.request("getProductList", {
              coupon_id: this.couponsDetail.coupon.id,
              page: this.page,
              page_size: this.page_size
            });
          });
          break;
        case "getProductList":
          httper.post(
            "/coupon/usable-pro",
            requestData,
            res => {
              if (res.code == 0) {
                this.productList = res.data;
              } else {
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
      }
    }
  }
};
</script>
<style scoped>
.pro_coupon_top {
  width: calc(100% - 40px);
  margin: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
}
.pro_coupon_name {
  width: 100%;
  border-bottom: 1px solid #d2d2d2;
  padding-bottom: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  font-size: 15px;
}
.pro_coupon_desc {
  color: #bbbbbb;
  font-size: 14px;
}
.pro_productlist {
  width: calc(100% - 40px);
  margin: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
}
.pro_product_title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.pro_product_box {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.pro_productimg {
  width: 115px;
  height: 115px;
  border-radius: 5px;
  margin-right: 15px;
}
.pro_productRight {
  width: calc(100% - 130px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.pro_productName {
  font-size: 15px;
}
.pro_productPrice {
  font-size: 16px;
  color: #ff7608;
}
</style>



// WEBPACK FOOTER //
// src/pages/kaquan/couponDetailPro.vue